import React, { createContext, useContext, useState, useCallback, useMemo } from "react";

const STORAGE_KEY = "qt_lang";

export const languages = [
  { code: "de", label: "DE", name: "Deutsch" },
  { code: "it", label: "IT", name: "Italiano" },
  { code: "en", label: "EN", name: "English" },
];

// Full UI translation dictionary.
export const dict = {
  de: {
    "nav.home": "Startseite",
    "nav.about": "Über uns",
    "nav.menu": "Speisekarte",
    "nav.gallery": "Galerie",
    "mail.autoBooking": "Danke für deine Reservierungsanfrage bei Quattro Tavoli! Wir haben sie erhalten und melden uns so schnell wie möglich bei dir, um deinen Tisch zu bestätigen. Bis bald! Dein Quattro-Tavoli-Team",
    "mail.autoEvent": "Danke für deine Anfrage bei Quattro Tavoli! Wir haben sie erhalten und melden uns bald bei dir, um die Details zu besprechen. Dein Quattro-Tavoli-Team",
    "nav.visit": "Besuch",
    "nav.reserve": "Tisch reservieren",
    "nav.takeaway": "Take Away bestellen",
    "nav.events": "Events & Catering",
    "eventspage.eyebrow": "Catering & Events",
    "eventspage.title1": "Feiert",
    "eventspage.title2": "bei uns",
    "eventspage.intro": "Das Quattro Tavoli ist der richtige Ort für Geburtstage, Hochzeiten und Firmenevents. Ein gemütliches Lokal, in dem man mit gutem Essen, guter Gesellschaft und ein bisschen Musik den Abend feiert.",
    "eventspage.hoursLabel": "Öffnungszeiten",
    "eventspage.hoursVal": "18:00 – 23:30 Uhr, spätestens bis Mitternacht.",
    "eventspage.guestsLabel": "Gäste",
    "eventspage.guestsVal": "Von 25 bis 35 Personen, bis zu 40 mit Buffet.",
    "eventspage.formulasTitle": "Zwei Formeln",
    "eventspage.formula1": "Menü am Tisch: drei Gänge zum Teilen.",
    "eventspage.formula2": "Aperitivo-Buffet (Apericena).",
    "eventspage.cateringTitle": "Catering",
    "eventspage.cateringText": "Die Küche des Quattro Tavoli auch bei euch zu Hause: Essen zum Mitnehmen in großen Mengen, ohne Personal, für Tafeln bis zu etwa 40 Personen. Lasagne, Aufläufe, Aufschnitt, Käse und vegetarische Salate: Wir sind kein Catering-Unternehmen, sondern ein Bistro, das auch für große Runden mit Liebe kocht.",
    "eventspage.formTitle": "Schreibt uns für ein Angebot",
    "eventspage.guestsField": "Anzahl Gäste",
    "eventspage.guestsPh": "z.B. 30",
    "eventspage.success.title": "Vielen Dank!",
    "eventspage.success.text": "Deine Anfrage ist eingegangen. Wir melden uns so schnell wie möglich mit einem Angebot.",
    "eventspage.success.again": "Weitere Anfrage senden",
    "events.form.sub": "Wir melden uns so schnell wie möglich mit einem Angebot.",
    "events.form.name": "Vor- und Nachname",
    "events.form.email": "E-Mail",
    "events.form.phone": "Telefon",
    "events.form.message": "Deine Anfrage",
    "events.form.msgPh": "Erzähl uns von deinem Event...",
    "events.form.submit": "Anfrage senden",
    "events.form.sending": "Wird gesendet…",
    "events.toast.fillTitle": "Bitte ausfüllen",
    "events.toast.fillDesc": "Name, gültige E-Mail und Telefon sind erforderlich.",
    "events.toast.okTitle": "Grazie mille!",
    "events.toast.okDesc": "Deine Anfrage ist eingegangen. Wir melden uns bald.",
    "events.toast.errTitle": "Ups!",
    "events.toast.errDesc": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
    "hero.badge": "Italienisches Bistro",
    "hero.subtitle": "Ein kleiner Urlaub im Alltag – vier Tische, unzählige Momente italienischer Gemütlichkeit im Herzen Münchens.",
    "hero.cta.menu": "Speisekarte entdecken",
    "about.eyebrow": "Über uns",
    "about.title1": "Benvenuti nel nostro",
    "about.title2": "piccolo mondo",
    "about.p1": "Das Quattro Tavoli entstand 2011 aus der Idee einer Gruppe von Freunden aus Bologna, die einen einfachen Traum hatten: ein Bistro voller Musik, Fröhlichkeit und italienischem Lebensgefühl zu schaffen. Mit der Zeit wuchs das Team und nahm weitere italienische Jungs auf, die Farbe, Energie und neue Nuancen in diese kleine Welt brachten. Heute ist das Quattro Tavoli ein fester Bezugspunkt im Dreimühlenviertel in München: ein Ort, den man zufällig betritt und gerne bleibt. Hier ist die Atmosphäre herzlich und aufrichtig, und die Zeit vergeht langsamer. Man isst gut – einfache, aber mit Liebe zubereitete Gerichte – und verbringt unbeschwerte Stunden in guter Gesellschaft. Unsere Karte bietet eine kleine Auswahl an Weinen, Antipasti und Primi, die man im Sommer auch auf unserer Terrasse genießen kann.",
    "about.p2": "Im Dreimühlenviertel gelegen, empfängt euch das Quattro Tavoli mit handbemalten italienischen Fliesen, warmem Licht und dem Duft von frischer Pasta. Hier wird das Leben zelebriert – mit ehrlicher Küche, gutem Wein und viel Herz.",
    "about.stat1": "Tische, ein Zuhause",
    "about.stat2": "seit im Viertel",
    "about.stat3": "hausgemacht",
    "about.badge": "Dolce Vita seit 2013",
    "menu.eyebrow": "La Cucina",
    "menu.title1": "Unsere",
    "menu.title2": "Köstlichkeiten",
    "menu.sub": "Täglich frisch, mit Zutaten aus Bella Italia. Eine Auswahl unserer Lieblinge – auch als Take Away bis 21:30 Uhr.",
    "menu.viewall": "Ganze Speisekarte ansehen",
    "gallery.eyebrow": "Impressioni",
    "gallery.title1": "Momente aus dem",
    "gallery.title2": "Quattro Tavoli",
    "gallery.sub": "Vom Aperitivo an der Bar bis zum letzten Bissen Tiramisù – ein Blick in unsere kleine italienische Welt.",
    "visit.eyebrow": "Besuch uns",
    "visit.title1": "Wir warten",
    "visit.title2": "stra-gerne",
    "visit.title3": "auf euch",
    "visit.sub": "Ragazzi belli – kommt vorbei oder reserviert euren Tisch.",
    "visit.hours": "Öffnungszeiten",
    "visit.addr": "Adresse",
    "visit.phone": "Telefon",
    "visit.email": "E-Mail",
    "visit.form.title": "Tisch reservieren",
    "visit.form.notice": "Dies ist keine automatische Reservierung, sondern eine Anfrage. Wir melden uns so schnell wie möglich mit der Bestätigung.",
    "visit.form.sub": "Nur vier Tische – sichert euch euren Platz.",
    "visit.form.name": "Name",
    "visit.form.email": "E-Mail",
    "visit.form.phone": "Telefon",
    "visit.form.date": "Datum",
    "visit.form.guests": "Personen",
    "visit.form.person": "Person",
    "visit.form.persons": "Personen",
    "visit.form.phoneOpt": "Telefon (optional)",
    "visit.form.msgOpt": "Nachricht (optional)",
    "visit.form.msgPh": "Besondere Wünsche...",
    "visit.form.submit": "Anfrage senden",
    "visit.form.sending": "Wird gesendet…",
    "visit.toast.fillTitle": "Bitte ausfüllen",
    "visit.toast.fillDesc": "Name, Datum, E-Mail und Telefon werden benötigt.",
    "visit.toast.pastTitle": "Datum prüfen",
    "visit.toast.pastDesc": "Bitte wählt ein Datum ab heute.",
    "visit.toast.errTitle": "Ups!",
    "visit.toast.errDesc": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
    "hours.lunch": "Mittagessen",
    "hours.lunch.days": "Montag & Freitag",
    "hours.dinner": "Abendessen",
    "hours.dinner.days": "Montag bis Freitag",
    "hours.sat": "Samstag",
    "hours.sat.days": "Nur geschlossene Gesellschaften",
    "hours.sat.time": "auf Anfrage",
    "hours.takeaway": "Küche und Take Away",
    "hours.takeaway.days": " ",
    "hours.takeaway.time": "bis 21:30",
    "notfound.title": "Diese Seite gibt es nicht",
    "notfound.text": "Vielleicht hat sich ein Tippfehler eingeschlichen oder die Seite ist umgezogen. Der Tisch wartet trotzdem auf euch.",
    "notfound.cta": "Zur Startseite",
    "testimonials.source": "Google Bewertung",
    "footer.tagline": "Italienisches Bistro im Herzen Münchens. Ein kleiner Urlaub im Alltag – mitten im Dreimühlenviertel.",
    "footer.nav": "Navigation",
    "footer.contact": "Kontakt",
    "footer.rights": "Alle Rechte vorbehalten.",
    "footer.love": "Fatto con amore",
    "cart.label": "Warenkorb",
    "cart.title": "Take Away",
    "cart.empty": "Dein Warenkorb ist leer.",
    "cart.emptySub": "Füge Gerichte aus der Speisekarte hinzu.",
    "cart.sum": "Summe",
    "cart.name": "Name",
    "cart.phone": "Telefon",
    "cart.pickup": "Abholzeit",
    "cart.notePh": "Notiz (optional)",
    "cart.payNote": "Zahlung bei Abholung.",
    "cart.email": "E-Mail",
    "cart.payNotice": "Bezahlt wird vor Ort im Restaurant bei Abholung – keine Online-Zahlung.",
    "cart.verifyIntro": "Zur Bestätigung senden wir dir einen Code per E-Mail.",
    "cart.getCode": "Code anfordern",
    "cart.sendingCode": "Wird gesendet…",
    "cart.codeSentTo": "Code gesendet an",
    "cart.codeLabel": "Bestätigungscode",
    "cart.codePh": "6-stelliger Code",
    "cart.placeOrder": "Bestellung abschicken",
    "cart.resend": "Code erneut senden",
    "cart.changeEmail": "E-Mail ändern",
    "cart.toast.emailInvalid": "Bitte eine gültige E-Mail-Adresse angeben.",
    "cart.toast.codeSentTitle": "Code gesendet",
    "cart.toast.codeSentDesc": "Bitte prüfe dein E-Mail-Postfach.",
    "cart.toast.codeErrDesc": "Code konnte nicht gesendet werden. Bitte erneut versuchen.",
    "cart.toast.invalidCode": "Ungültiger oder abgelaufener Code.",
    "cart.send": "Bestellung senden",
    "cart.sending": "Wird gesendet…",
    "cart.toast.fillTitle": "Bitte ausfüllen",
    "cart.toast.fillDesc": "Name und Telefon werden benötigt.",
    "cart.toast.emptyTitle": "Warenkorb leer",
    "cart.toast.emptyDesc": "Füge zuerst Gerichte hinzu.",
    "cart.toast.errTitle": "Ups!",
    "cart.toast.errDesc": "Bestellung fehlgeschlagen. Bitte erneut versuchen.",
    "cart.add": "Zum Warenkorb",
    "tst.1.text": "Wie ein kleiner Urlaub in Italien – herzlicher Service, ehrliche Küche. Der Aperol Spritz an der Bar ist Pflicht!",
    "tst.1.role": "Stammgast",
    "tst.2.text": "Das schönste Fliesen-Design im ganzen Viertel und die beste hausgemachte Pasta Münchens. Ragazzi belli!",
    "tst.2.role": "Foodblogger",
    "tst.3.text": "Klein, gemütlich, authentisch. Genau vier Tische an denen man die Zeit vergisst. Wir kommen immer wieder.",
    "tst.3.role": "Gäste seit 2018",
  },
  it: {
    "nav.home": "Home",
    "nav.about": "Chi siamo",
    "nav.menu": "Menù",
    "nav.gallery": "Galleria",
    "mail.autoBooking": "Grazie per la tua richiesta di prenotazione al Quattro Tavoli! L'abbiamo ricevuta e ti risponderemo il prima possibile per confermare il tavolo. A presto! Il team del Quattro Tavoli",
    "mail.autoEvent": "Grazie per la tua richiesta al Quattro Tavoli! L'abbiamo ricevuta e ti scriveremo presto per parlare dei dettagli. Il team del Quattro Tavoli",
    "nav.visit": "Vieni a trovarci",
    "nav.reserve": "Prenota un tavolo",
    "nav.takeaway": "Ordina d'asporto",
    "nav.events": "Eventi e catering",
    "eventspage.eyebrow": "Catering ed Eventi",
    "eventspage.title1": "Festeggia",
    "eventspage.title2": "da noi",
    "eventspage.intro": "Quattro Tavoli è il posto giusto per compleanni, matrimoni ed eventi aziendali. Un locale accogliente dove festeggiare con buon cibo, buona compagnia e un po' di musica ad accompagnare la serata.",
    "eventspage.hoursLabel": "Orari",
    "eventspage.hoursVal": "18:00 – 23:30, mezzanotte al massimo.",
    "eventspage.guestsLabel": "Ospiti",
    "eventspage.guestsVal": "Da 25 a 35 persone, fino a 40 con il buffet.",
    "eventspage.formulasTitle": "Due formule",
    "eventspage.formula1": "Menù a tavola: tre portate in versione sharing.",
    "eventspage.formula2": "Apericena a buffet.",
    "eventspage.cateringTitle": "Catering",
    "eventspage.cateringText": "La cucina di Quattro Tavoli anche a casa vostra: cibo da asporto in grandi quantità, senza personale, per tavolate fino a circa 40 persone. Lasagne, sformati, affettati, formaggi e insalate vegetariane: non siamo un'azienda di catering, ma un bistrot che cucina con amore anche per i grandi numeri.",
    "eventspage.formTitle": "Scriveteci per un preventivo",
    "eventspage.guestsField": "Numero di ospiti",
    "eventspage.guestsPh": "es. 30",
    "eventspage.success.title": "Grazie mille!",
    "eventspage.success.text": "Abbiamo ricevuto la tua richiesta. Ti risponderemo il prima possibile con un preventivo.",
    "eventspage.success.again": "Invia un'altra richiesta",
    "events.form.sub": "Ti risponderemo il prima possibile con un preventivo.",
    "events.form.name": "Nome e cognome",
    "events.form.email": "E-mail",
    "events.form.phone": "Telefono",
    "events.form.message": "La tua richiesta",
    "events.form.msgPh": "Raccontaci del tuo evento...",
    "events.form.submit": "Invia richiesta",
    "events.form.sending": "Invio in corso…",
    "events.toast.fillTitle": "Compila i campi",
    "events.toast.fillDesc": "Nome, e-mail valida e telefono sono obbligatori.",
    "events.toast.okTitle": "Grazie mille!",
    "events.toast.okDesc": "Abbiamo ricevuto la tua richiesta. Ti risponderemo presto.",
    "events.toast.errTitle": "Ops!",
    "events.toast.errDesc": "Qualcosa è andato storto. Riprova.",
    "hero.badge": "Bistrò Italiano",
    "hero.subtitle": "Una piccola vacanza nella quotidianità – quattro tavoli, infiniti momenti di convivialità italiana nel cuore di Monaco.",
    "hero.cta.menu": "Scopri il menù",
    "about.eyebrow": "Chi siamo",
    "about.title1": "Benvenuti nel nostro",
    "about.title2": "piccolo mondo",
    "about.p1": "Il Quattro Tavoli nasce nel 2011 dall'idea di un gruppo di amici bolognesi, con un sogno semplice: creare un bistrot fatto di musica, allegria e tanta italianità. Col tempo la squadra è cresciuta, accogliendo altri ragazzi italiani che hanno portato colore, energia e nuove sfumature a questo piccolo mondo. Oggi il Quattro Tavoli è un punto di riferimento nel Dreimühlenviertel di Monaco di Baviera: un posto dove si entra per caso e si resta volentieri. Qui l'atmosfera è affettuosa e sincera, e il tempo scorre più lento. Si mangia bene, con piatti semplici ma preparati con amore, e si passano ore spensierate in buona compagnia. Il nostro menù propone una piccola selezione di vini, antipasti e primi piatti, da gustare d'estate anche sulla nostra terrazza.",
    "about.p2": "Situato nel quartiere Dreimühlen, il Quattro Tavoli vi accoglie con piastrelle italiane dipinte a mano, luce calda e il profumo di pasta fresca. Qui si celebra la vita – con cucina genuina, buon vino e tanto cuore.",
    "about.stat1": "tavoli, una casa",
    "about.stat2": "dal nel quartiere",
    "about.stat3": "fatto in casa",
    "about.badge": "Dolce Vita dal 2013",
    "menu.eyebrow": "La Cucina",
    "menu.title1": "Le nostre",
    "menu.title2": "specialità",
    "menu.sub": "Ogni giorno fresco, con ingredienti dalla Bella Italia. Una selezione dei nostri preferiti – anche da asporto fino alle 21:30.",
    "menu.viewall": "Vedi tutto il menù",
    "gallery.eyebrow": "Impressioni",
    "gallery.title1": "Momenti al",
    "gallery.title2": "Tavoli",
    "gallery.sub": "Dall'aperitivo al bancone all'ultimo boccone di tiramisù – uno sguardo nel nostro piccolo mondo italiano.",
    "visit.eyebrow": "Vieni a trovarci",
    "visit.title1": "Vi aspettiamo",
    "visit.title2": "con piacere",
    "visit.title3": "",
    "visit.sub": "Ragazzi belli – passate a trovarci o prenotate il vostro tavolo.",
    "visit.hours": "Orari di apertura",
    "visit.addr": "Indirizzo",
    "visit.phone": "Telefono",
    "visit.email": "E-mail",
    "visit.form.title": "Prenota un tavolo",
    "visit.form.notice": "Questa non è una prenotazione automatica, ma una richiesta. Ti risponderemo il prima possibile con la conferma.",
    "visit.form.sub": "Solo quattro tavoli – assicuratevi il vostro posto.",
    "visit.form.name": "Nome",
    "visit.form.email": "E-mail",
    "visit.form.phone": "Telefono",
    "visit.form.date": "Data",
    "visit.form.guests": "Persone",
    "visit.form.person": "Persona",
    "visit.form.persons": "Persone",
    "visit.form.phoneOpt": "Telefono (opzionale)",
    "visit.form.msgOpt": "Messaggio (opzionale)",
    "visit.form.msgPh": "Richieste particolari...",
    "visit.form.submit": "Invia richiesta",
    "visit.form.sending": "Invio in corso…",
    "visit.toast.fillTitle": "Compila i campi",
    "visit.toast.fillDesc": "Nome, data, e-mail e telefono sono obbligatori.",
    "visit.toast.pastTitle": "Controlla la data",
    "visit.toast.pastDesc": "Scegliete una data da oggi in poi.",
    "visit.toast.errTitle": "Ops!",
    "visit.toast.errDesc": "Qualcosa è andato storto. Riprova.",
    "hours.lunch": "Pranzo",
    "hours.lunch.days": "Lunedì & Venerdì",
    "hours.dinner": "Cena",
    "hours.dinner.days": "Da lunedì a venerdì",
    "hours.sat": "Sabato",
    "hours.sat.days": "Solo eventi privati",
    "hours.sat.time": "su richiesta",
    "hours.takeaway": "Cucina e asporto",
    "hours.takeaway.days": "",
    "hours.takeaway.time": "fino alle 21:30",
    "notfound.title": "Questa pagina non esiste",
    "notfound.text": "Forse c'è un errore di battitura nell'indirizzo o la pagina è stata spostata. Il tavolo vi aspetta comunque.",
    "notfound.cta": "Torna alla home",
    "testimonials.source": "Recensione Google",
    "footer.tagline": "Bistrò italiano nel cuore di Monaco. Una piccola vacanza nella quotidianità – nel quartiere Dreimühlen.",
    "footer.nav": "Navigazione",
    "footer.contact": "Contatti",
    "footer.rights": "Tutti i diritti riservati.",
    "footer.love": "Fatto con amore",
    "cart.label": "Carrello",
    "cart.title": "Da asporto",
    "cart.empty": "Il tuo carrello è vuoto.",
    "cart.emptySub": "Aggiungi piatti dal menù.",
    "cart.sum": "Totale",
    "cart.name": "Nome",
    "cart.phone": "Telefono",
    "cart.pickup": "Orario di ritiro",
    "cart.notePh": "Nota (opzionale)",
    "cart.payNote": "Pagamento al ritiro.",
    "cart.email": "E-mail",
    "cart.payNotice": "Il pagamento si effettua in loco al ritiro – nessun pagamento online.",
    "cart.verifyIntro": "Per conferma ti inviamo un codice via e-mail.",
    "cart.getCode": "Richiedi codice",
    "cart.sendingCode": "Invio in corso…",
    "cart.codeSentTo": "Codice inviato a",
    "cart.codeLabel": "Codice di conferma",
    "cart.codePh": "Codice a 6 cifre",
    "cart.placeOrder": "Invia ordine",
    "cart.resend": "Invia di nuovo il codice",
    "cart.changeEmail": "Cambia e-mail",
    "cart.toast.emailInvalid": "Inserisci un indirizzo e-mail valido.",
    "cart.toast.codeSentTitle": "Codice inviato",
    "cart.toast.codeSentDesc": "Controlla la tua casella e-mail.",
    "cart.toast.codeErrDesc": "Impossibile inviare il codice. Riprova.",
    "cart.toast.invalidCode": "Codice non valido o scaduto.",
    "cart.send": "Invia ordine",
    "cart.sending": "Invio in corso…",
    "cart.toast.fillTitle": "Compila i campi",
    "cart.toast.fillDesc": "Nome e telefono sono obbligatori.",
    "cart.toast.emptyTitle": "Carrello vuoto",
    "cart.toast.emptyDesc": "Aggiungi prima dei piatti.",
    "cart.toast.errTitle": "Ops!",
    "cart.toast.errDesc": "Ordine non riuscito. Riprova.",
    "cart.add": "Aggiungi al carrello",
    "tst.1.text": "Come una piccola vacanza in Italia – servizio cordiale, cucina genuina. L'Aperol Spritz al bancone è d'obbligo!",
    "tst.1.role": "Cliente abituale",
    "tst.2.text": "Il design di piastrelle più bello di tutto il quartiere e la migliore pasta fatta in casa di Monaco. Ragazzi belli!",
    "tst.2.role": "Foodblogger",
    "tst.3.text": "Piccolo, accogliente, autentico. Proprio quattro tavoli dove si perde la cognizione del tempo. Torniamo sempre.",
    "tst.3.role": "Ospiti dal 2018",
  },
  en: {
    "nav.home": "Home",
    "nav.about": "About",
    "nav.menu": "Menu",
    "nav.gallery": "Gallery",
    "mail.autoBooking": "Thank you for your booking request at Quattro Tavoli! We've received it and will get back to you as soon as possible to confirm your table. See you soon! The Quattro Tavoli team",
    "mail.autoEvent": "Thank you for your enquiry at Quattro Tavoli! We've received it and will get back to you soon to discuss the details. The Quattro Tavoli team",
    "nav.visit": "Visit",
    "nav.reserve": "Reserve a table",
    "nav.takeaway": "Order for Takeaway",
    "nav.events": "Events & Catering",
    "eventspage.eyebrow": "Catering & Events",
    "eventspage.title1": "Celebrate",
    "eventspage.title2": "with us",
    "eventspage.intro": "Quattro Tavoli is the perfect place for birthdays, weddings and company events. A cosy venue to celebrate with good food, good company and a bit of music to accompany the evening.",
    "eventspage.hoursLabel": "Hours",
    "eventspage.hoursVal": "6:00 – 11:30 pm, midnight at the latest.",
    "eventspage.guestsLabel": "Guests",
    "eventspage.guestsVal": "From 25 to 35 people, up to 40 with the buffet.",
    "eventspage.formulasTitle": "Two formats",
    "eventspage.formula1": "Menu at the table: three courses served sharing-style.",
    "eventspage.formula2": "Aperitivo buffet (apericena).",
    "eventspage.cateringTitle": "Catering",
    "eventspage.cateringText": "The kitchen of Quattro Tavoli in your home too: take-away food in large quantities, without staff, for tables of up to around 40 people. Lasagne, bakes, cold cuts, cheeses and vegetarian salads: we're not a catering company, but a bistro that cooks with love even for big numbers.",
    "eventspage.formTitle": "Write to us for a quote",
    "eventspage.guestsField": "Number of guests",
    "eventspage.guestsPh": "e.g. 30",
    "eventspage.success.title": "Thank you!",
    "eventspage.success.text": "We've received your request. We'll get back to you as soon as possible with a quote.",
    "eventspage.success.again": "Send another request",
    "events.form.sub": "We'll get back to you as soon as possible with a quote.",
    "events.form.name": "Full name",
    "events.form.email": "Email",
    "events.form.phone": "Phone",
    "events.form.message": "Your request",
    "events.form.msgPh": "Tell us about your event...",
    "events.form.submit": "Send request",
    "events.form.sending": "Sending…",
    "events.toast.fillTitle": "Please fill in",
    "events.toast.fillDesc": "Name, a valid email and phone are required.",
    "events.toast.okTitle": "Grazie mille!",
    "events.toast.okDesc": "We received your request. We'll be in touch soon.",
    "events.toast.errTitle": "Oops!",
    "events.toast.errDesc": "Something went wrong. Please try again.",
    "hero.badge": "Italian Bistro",
    "hero.subtitle": "A little getaway from everyday life – four tables, countless moments of Italian warmth in the heart of Munich.",
    "hero.cta.menu": "Explore the menu",
    "about.eyebrow": "About us",
    "about.title1": "Benvenuti nel nostro",
    "about.title2": "piccolo mondo",
    "about.p1": "Quattro Tavoli was born in 2011 from the idea of a group of friends from Bologna, with a simple dream: to create a bistro full of music, joy and Italian spirit. Over time the team grew, welcoming other Italian guys who brought colour, energy and new nuances to this little world. Today Quattro Tavoli is a landmark in Munich's Dreimühlen quarter: a place you enter by chance and happily stay. Here the atmosphere is warm and sincere, and time flows more slowly. You eat well – simple dishes prepared with love – and spend carefree hours in good company. Our menu offers a small selection of wines, antipasti and primi, to enjoy on our terrace in summer too.",
    "about.p2": "Nestled in the Dreimühlen quarter, Quattro Tavoli welcomes you with hand-painted Italian tiles, warm light and the aroma of fresh pasta. Here life is celebrated – with honest cooking, good wine and lots of heart.",
    "about.stat1": "tables, one home",
    "about.stat2": "in the quarter since",
    "about.stat3": "homemade",
    "about.badge": "Dolce Vita since 2013",
    "menu.eyebrow": "La Cucina",
    "menu.title1": "Our",
    "menu.title2": "delicacies",
    "menu.sub": "Fresh every day, with ingredients from Bella Italia. A selection of our favourites – also available as Take Away until 9:30 pm.",
    "menu.viewall": "View the full menu",
    "gallery.eyebrow": "Impressioni",
    "gallery.title1": "Moments at the",
    "gallery.title2": "Tavoli",
    "gallery.sub": "From an aperitivo at the bar to the last bite of tiramisù – a glimpse into our little Italian world.",
    "visit.eyebrow": "Visit us",
    "visit.title1": "We can't",
    "visit.title2": "wait",
    "visit.title3": "to see you",
    "visit.sub": "Ragazzi belli – drop by or reserve your table.",
    "visit.hours": "Opening hours",
    "visit.addr": "Address",
    "visit.phone": "Phone",
    "visit.email": "Email",
    "visit.form.title": "Reserve a table",
    "visit.form.notice": "This is not an automatic reservation, it is a booking request. We will get back to you as soon as possible to confirm.",
    "visit.form.sub": "Only four tables – secure your spot.",
    "visit.form.name": "Name",
    "visit.form.email": "Email",
    "visit.form.phone": "Phone",
    "visit.form.date": "Date",
    "visit.form.guests": "Guests",
    "visit.form.person": "person",
    "visit.form.persons": "guests",
    "visit.form.phoneOpt": "Phone (optional)",
    "visit.form.msgOpt": "Message (optional)",
    "visit.form.msgPh": "Special requests...",
    "visit.form.submit": "Send request",
    "visit.form.sending": "Sending…",
    "visit.toast.fillTitle": "Please fill in",
    "visit.toast.fillDesc": "Name, date, email and phone are required.",
    "visit.toast.pastTitle": "Check the date",
    "visit.toast.pastDesc": "Please pick today or a later date.",
    "visit.toast.errTitle": "Oops!",
    "visit.toast.errDesc": "Something went wrong. Please try again.",
    "hours.lunch": "Lunch",
    "hours.lunch.days": "Monday & Friday",
    "hours.dinner": "Dinner",
    "hours.dinner.days": "Monday to Friday",
    "hours.sat": "Saturday",
    "hours.sat.days": "Private events only",
    "hours.sat.time": "on request",
    "hours.takeaway": "Kitchen and Take Away",
    "hours.takeaway.days": "",
    "hours.takeaway.time": "until 9:30 pm",
    "notfound.title": "This page does not exist",
    "notfound.text": "There may be a typo in the address, or the page has moved. Your table is still waiting for you.",
    "notfound.cta": "Back to home",
    "testimonials.source": "Google Review",
    "footer.tagline": "Italian bistro in the heart of Munich. A little getaway from everyday life – in the Dreimühlen quarter.",
    "footer.nav": "Navigation",
    "footer.contact": "Contact",
    "footer.rights": "All rights reserved.",
    "footer.love": "Fatto con amore",
    "cart.label": "Cart",
    "cart.title": "Take Away",
    "cart.empty": "Your cart is empty.",
    "cart.emptySub": "Add dishes from the menu.",
    "cart.sum": "Total",
    "cart.name": "Name",
    "cart.phone": "Phone",
    "cart.pickup": "Pickup time",
    "cart.notePh": "Note (optional)",
    "cart.payNote": "Payment on pickup.",
    "cart.email": "Email",
    "cart.payNotice": "Payment is made in person at the restaurant on pickup – no online payment.",
    "cart.verifyIntro": "To confirm, we'll send you a code by email.",
    "cart.getCode": "Request code",
    "cart.sendingCode": "Sending…",
    "cart.codeSentTo": "Code sent to",
    "cart.codeLabel": "Confirmation code",
    "cart.codePh": "6-digit code",
    "cart.placeOrder": "Place order",
    "cart.resend": "Resend code",
    "cart.changeEmail": "Change email",
    "cart.toast.emailInvalid": "Please enter a valid email address.",
    "cart.toast.codeSentTitle": "Code sent",
    "cart.toast.codeSentDesc": "Please check your email inbox.",
    "cart.toast.codeErrDesc": "Could not send the code. Please try again.",
    "cart.toast.invalidCode": "Invalid or expired code.",
    "cart.send": "Send order",
    "cart.sending": "Sending…",
    "cart.toast.fillTitle": "Please fill in",
    "cart.toast.fillDesc": "Name and phone are required.",
    "cart.toast.emptyTitle": "Cart empty",
    "cart.toast.emptyDesc": "Add some dishes first.",
    "cart.toast.errTitle": "Oops!",
    "cart.toast.errDesc": "Order failed. Please try again.",
    "cart.add": "Add to cart",
    "tst.1.text": "Like a little holiday in Italy – warm service, honest cooking. The Aperol Spritz at the bar is a must!",
    "tst.1.role": "Regular guest",
    "tst.2.text": "The most beautiful tile design in the whole quarter and the best homemade pasta in Munich. Ragazzi belli!",
    "tst.2.role": "Food blogger",
    "tst.3.text": "Small, cosy, authentic. Just four tables where you lose track of time. We keep coming back.",
    "tst.3.role": "Guests since 2018",
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem(STORAGE_KEY) || "de");

  const setLang = useCallback((code) => {
    localStorage.setItem(STORAGE_KEY, code);
    setLangState(code);
  }, []);

  const t = useCallback(
    (key) => (dict[lang] && dict[lang][key]) || dict.de[key] || key,
    [lang]
  );

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
